import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from './AuthContext';
import './ChangePassword.css';

const ChangePassword = () => {
  const navigate = useNavigate();
  const { changePassword } = useAuth();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  
  const [formData, setFormData] = useState({
    old_password: '',
    new_password: '',
    confirm_password: '',
  });

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
    setError('');
  };

  const validatePassword = (password) => {
    if (password.length < 8) {
      return '密码长度至少为8位';
    }
    if (!/(?=.*[a-z])/.test(password)) {
      return '密码必须包含至少一个小写字母';
    }
    if (!/(?=.*[A-Z])/.test(password)) {
      return '密码必须包含至少一个大写字母';
    }
    if (!/(?=.*\d)/.test(password)) {
      return '密码必须包含至少一个数字';
    }
    return null;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    setSuccess('');

    // 验证新密码
    const passwordError = validatePassword(formData.new_password);
    if (passwordError) {
      setError(passwordError);
      setLoading(false);
      return;
    }

    // 验证密码确认
    if (formData.new_password !== formData.confirm_password) {
      setError('两次输入的新密码不一致');
      setLoading(false);
      return;
    }

    // 验证新旧密码不同
    if (formData.old_password === formData.new_password) {
      setError('新密码不能与旧密码相同');
      setLoading(false);
      return;
    }

    try {
      await changePassword(formData.old_password, formData.new_password);
      setSuccess('密码修改成功！即将跳转到登录页面...');
      
      // 清空表单
      setFormData({
        old_password: '',
        new_password: '',
        confirm_password: '',
      });

      // 3秒后跳转到登录页
      setTimeout(() => {
        navigate('/login');
      }, 3000);
    } catch (err) {
      setError(err.response?.data?.detail || '密码修改失败，请重试');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="change-password-container">
      <div className="change-password-card">
        <button className="back-btn" onClick={() => navigate(-1)}>
          ← 返回
        </button>

        <h2 className="change-password-title">修改密码</h2>

        {error && <div className="change-password-error">{error}</div>}
        {success && <div className="change-password-success">{success}</div>}

        <form onSubmit={handleSubmit} className="change-password-form">
          <div className="form-group">
            <label htmlFor="old_password">当前密码</label>
            <input
              type="password"
              id="old_password"
              name="old_password"
              value={formData.old_password}
              onChange={handleChange}
              placeholder="请输入当前密码"
              required
            />
          </div>

          <div className="form-group">
            <label htmlFor="new_password">新密码</label>
            <input
              type="password"
              id="new_password"
              name="new_password"
              value={formData.new_password}
              onChange={handleChange}
              placeholder="请输入新密码"
              required
            />
            <small className="password-hint">
              密码需包含：至少8位、大小写字母和数字
            </small>
          </div>

          <div className="form-group">
            <label htmlFor="confirm_password">确认新密码</label>
            <input
              type="password"
              id="confirm_password"
              name="confirm_password"
              value={formData.confirm_password}
              onChange={handleChange}
              placeholder="请再次输入新密码"
              required
            />
          </div>

          <button 
            type="submit" 
            className="change-password-btn"
            disabled={loading}
          >
            {loading ? '修改中...' : '确认修改'}
          </button>
        </form>

        <div className="password-tips">
          <h3>密码安全提示</h3>
          <ul>
            <li>密码长度至少为8个字符</li>
            <li>包含大小写字母和数字</li>
            <li>不要使用容易被猜到的信息（如生日、手机号）</li>
            <li>定期更换密码可以提高账户安全性</li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default ChangePassword;
